//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import Filters from './TableFilters.vue';
import Modal from './Modal.vue';
import constant from '~/const';

import tableConfig from './tableConfig';
import actionsConfig from './actionsConfig';

export default {
  components: { Filters, Modal },

  data() {
    return {
      editingRate: {
        show: false,
        data: {},
        isCreating: false,
      },
      tableConfig,
      actionsConfig,
      selection: [],
      constant,
      loader: false,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('tradersRates', {
      data: 'data',
      currencies: 'currencies',
      methods: 'paymentMethodsWithSources',
    }),

    getDirections() {
      return [
        {
          id: 1,
          caption: this.$t('Buy'),
        },
        {
          id: 2,
          caption: this.$t('Sell'),
        },
      ];
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('tradersRates', {
      loadDataAction: 'loadData',
      editRatesAction: 'editRates',
      deleteRateAction: 'deleteRate',
    }),

    filteredPaymentMethods(value, currency) {
      return this.methods.filter((method) => {
        return value.includes(method.sourceAssignedId) && method.currencyCode === currency;
      });
    },

    filteredSource(source) {
      return Object.keys(source).reduce((acc, key) => {
        if (this.isValidValue(source[key])) {
          acc[key] = source[key];
        }
        return acc;
      }, {});
    },

    isValidValue(value) {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === 'object' && value !== null) {
        return Object.keys(value).length > 0;
      }
      return value !== null && value !== undefined && value !== '' && value !== 0;
    },

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
      this.loader = false;
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },

    openModalEditRate(row) {
      this.editingRate.show = true;
      this.editingRate.data = { ...row };
      this.editingRate.isCreating = false;
    },

    openCreateRateModal() {
      this.editingRate.show = true;
      this.editingRate.data = {};
      this.editingRate.isCreating = true;
    },

    applyEdit(payload) {
      const { isCreating } = this.editingRate;
      this.confirmAction({
        title: isCreating
          ? 'Are you sure you want to create rate?'
          : 'Are you sure you want to update rate?',
        callback: async () => {
          this.setGeneralProgress(true);
          this.loader = true;
          const { id, ...rest } = payload;
          try {
            await this.editRatesAction({ ...rest });
            this.editingRate.show = false;
            await this.loadDataAction({});
            this.setSuccessNotification(isCreating ? 'Rate created' : 'Rate updated');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralProgress(false);
          this.loader = false;
        },
      });
    },

    deleteRate(input) {
      this.confirmAction({
        title: 'Are you sure you want to delete rate?',
        callback: async () => {
          this.setGeneralProgress(true);
          this.loader = true;
          try {
            await this.deleteRateAction(input);
            await this.loadDataAction({});
            this.setSuccessNotification('Rate deleted');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralProgress(false);
          this.loader = false;
        },
      });
    },

    applyFilters() {
      this.loadData();
    },
  },
};
